import BlocksSubHeader from "../../../components/Blocks/BlocksSubHeader";
import GeneralBlockList from "../../../components/GeneralBlock/GeneralBlock";
import Header from "../../../components/Header/Header";
import SideNavbar from "../../../components/Navbar/SideNavbar";

const GeneralBlocks = () => {
    return (
        <>
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <BlocksSubHeader />
                        <GeneralBlockList />
                    </div>
                </div>
            </div>
        </>
    )
}
export default GeneralBlocks;